import { useState } from "react";
import { Heart, Share2, Volume2, VolumeX } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { logger } from "../../lib/logger";

const shareVideo = async (video) => {
  const url = `${window.location.origin}/watch/${video.id}`;
  if (navigator.share) {
    try { await navigator.share({ title: video.title, url }); return; }
    catch (err) { if (err?.name !== "AbortError") logger.warn("[shorts] native share failed:", err); }
  }
  try { await navigator.clipboard.writeText(url); toast.success("Lien copié"); }
  catch (err) { logger.warn("[shorts] clipboard failed:", err); toast.error("Impossible de copier"); }
};

const ActionButton = ({ testid, onClick, label, children }) => (
  <button data-testid={testid} onClick={onClick} className="flex flex-col items-center gap-0.5 text-white hover:text-[color:var(--accent)] transition">
    <span className="w-11 h-11 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center border border-white/10 hover:bg-white/20 transition">{children}</span>
    <span className="text-[9px] uppercase tracking-wider font-mono">{label}</span>
  </button>
);

/** Like / share / mute column of the Shorts overlay. */
export const ShortsActions = ({ current, muted, onToggleMuted }) => {
  const [liked, setLiked] = useState({});
  const isLiked = !!liked[current?.id];

  const like = async () => {
    if (!current) return;
    setLiked(prev => ({ ...prev, [current.id]: !prev[current.id] }));
    try { await api.post(`/videos/${current.id}/like`); }
    catch (err) { logger.warn("[shorts] like POST failed:", err); }
  };

  return (
    <div className="flex flex-col gap-3 pointer-events-auto">
      <ActionButton testid="shorts-like" onClick={like} label={(current?.likes ?? 0) + (isLiked ? 1 : 0)}>
        <Heart className={`w-5 h-5 ${isLiked ? "fill-[color:var(--accent)] text-[color:var(--accent)]" : ""}`} />
      </ActionButton>
      <ActionButton testid="shorts-share" onClick={() => current && shareVideo(current)} label="Part">
        <Share2 className="w-5 h-5" />
      </ActionButton>
      <ActionButton testid="shorts-mute" onClick={onToggleMuted} label={muted ? "Son" : "Mute"}>
        {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
      </ActionButton>
    </div>
  );
};
